export const gnbHeight = 64;
export const subNavHeight = 54;

export const GLOBAL_TOP_HEADER_HEIGHT = 64;
export const GLOBAL_BOTTOM_HEADER_HEIGHT = 48;
export const TOP_BANNER_HEIGHT = 56;
